const contentBarHeight = 64;
const heightOffset = 64;
const MIN_CONTENT_WIDTH = 600;			// reserved width for question content; side panels collapse to drawers below this

export {
	contentBarHeight,
	heightOffset,
	MIN_CONTENT_WIDTH
}